import { AlertTriangle } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'
import { useOwnerSuspension } from '../hooks/useOwnerSuspension'

/**
 * 休会中であることをオーナーに伝えるバナー (#1683)。
 *
 * **画面を塞がない。** 休会中にオーナーがやるべきことは支払いと、休会前に
 * 入っている予約の後始末で、そのどちらもアプリの中にある。モーダルで覆うと
 * 支払いにも予約にもたどり着けず、取り立てが自分で遠のく (規約 11.5 第 3 項)。
 *
 * 理由 (「8月分未入金」等) はそのまま出す。オーナー自身の支払いに関する事実で、
 * 隠すと何をすれば解除されるのか分からない。顧客向けの画面には出さない。
 */
export default function StoreSuspensionBanner() {
  const { t } = useI18n()
  const { suspended, reason } = useOwnerSuspension()
  if (!suspended) return null

  return (
    // 上端に置くので、ノッチと DEMO 帯 (fixed overlay) の下に本文が来るよう
    // 明示的に逃がす。safe-top だけだとデスクトップで 0 になり DEMO 帯に隠れる。
    <div
      className="border-b border-yokoso-red/20 bg-yokoso-red/10 px-4 pb-3"
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 1.5rem)' }}
    >
      <div className="mx-auto flex max-w-3xl items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-yokoso-red" />
        <div className="min-w-0">
          <p className="font-body text-[13px] font-bold text-yokoso-red">
            {t('storeSuspension.title')}
          </p>
          {reason && (
            <p className="mt-0.5 font-body text-[12px] text-text-secondary">
              {t('storeSuspension.reason')}: {reason}
            </p>
          )}
          <p className="mt-1 font-body text-[12px] text-text-secondary">
            {t('storeSuspension.stopped')}
          </p>
          <p className="mt-1 font-body text-[12px] text-text-secondary">
            {t('storeSuspension.stillAvailable')}
          </p>
          <p className="mt-1 font-body text-[12px] text-text-tertiary">
            {t('storeSuspension.howToResume')}
          </p>
        </div>
      </div>
    </div>
  )
}
